import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CommonSnackBarService } from "../_services/common-snack-bar.service";
import { DeviceDataExportService } from "../_services/device-data-export/brian-device-export.service";
import { DistributionManagementService } from "../_services/http-api/distribution-management.service";
import { SpinnerService } from "../_services/spinner.service";
import { VERSION } from "../app.constants";
import { CommonConfirmDialogComponent } from "../common-dialog/common-confirm-dialog.component";
import { AppAboutComponent } from "../app-about/app-about.component";
import { EvcModalService } from "../_shared/services/modal/evc-modal.service";

@Injectable({
  providedIn: "root"
})
export class TopBarMenuService {
  constructor(
    private dialog: MatDialog,
    private distributionManagementService: DistributionManagementService,
    private snackBar: CommonSnackBarService,
    private oscSpinnerService: SpinnerService,
    private translate: TranslateService,
    private deviceDataExportService: DeviceDataExportService,
    private evcModalService: EvcModalService
  ) {}

  downloadDesktopApp() {
    const desktopVersion = VERSION;

    this.oscSpinnerService.show();
    this.distributionManagementService.getAppExe(desktopVersion).subscribe({
      next: (dlInfo) => {
        if (dlInfo.isNewestVersion) {
          window.open(dlInfo.url, "_self");
          this.oscSpinnerService.hide();
        } else {
          this.oscSpinnerService.hide();
          const dialogRef = this.openDownloadConfirmationDialog();
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              window.open(dlInfo.url, "_self");
            }
          });
        }
      },
      error: (error) => {
        this.oscSpinnerService.hide();
        this.snackBar.open(this.translate.instant("settingsOverlay.getAppExeError"));
      }
    });
  }

  openLegalDialog(): void {
    this.evcModalService.showModal(AppAboutComponent);
  }

  openDownloadConfirmationDialog() {
    return this.dialog.open(CommonConfirmDialogComponent, {
      width: "500px",
      height: "220px",
      data: {
        firstMessage: this.translate.instant("exefileDownloadConfirmDialog.confirmText1"),
        secondMessage: this.translate.instant("exefileDownloadConfirmDialog.confirmText2"),
        trueBtnText: this.translate.instant("exefileDownloadConfirmDialog.download"),
        falseBtnText: this.translate.instant("exefileDownloadConfirmDialog.cancel"),
        dialogType: "confirmation"
      }
    });
  }

  goToVisolHelp() {
    window.open("https://view.highspot.com/viewer/62a26e0cca4fd80a15b6dddf", "_blank");
  }

  sharePresetDataWithDevice() {
    this.oscSpinnerService.show(true);
    this.deviceDataExportService.exportPresetDataToDevice().subscribe(
      (_) => {
        this.oscSpinnerService.hide(true);
        this.snackBar.open(this.translate.instant("settingsOverlay.presetDataDownloadSuccessful"));
      },
      (e) => {
        this.oscSpinnerService.hide(true);
        this.snackBar.open(this.translate.instant("settingsOverlay.exportPresetDataError"));
      }
    );
  }
}
